module.exports = __webpack_public_path__ + "static/media/resume.394672c9.svg";